export default __webpack_public_path__ + "static/media/dart.35e3ba58.svg";